export default __webpack_public_path__ + "static/media/Harriet 9781846161674.7b9ed06f.jpg";